var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPotatoesBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.328,
    height: 53.327,
    viewBox: "0 0 52.328 53.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11227",
    "data-name": "Rectangle 11227",
    width: 52.328,
    height: 53.327,
    fill: "#22294b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3019",
    "data-name": "Group 3019",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3464",
    "data-name": "Path 3464",
    d: "M40.65,27.652a1.1,1.1,0,0,1-1.083-1.318,13.942,13.942,0,0,0-.168-6.151,1.1,1.1,0,1,1,2.136-.55,16.161,16.161,0,0,1,.2,7.13A1.1,1.1,0,0,1,40.65,27.652Z",
    transform: "translate(-10.421 -4.977)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3465",
    "data-name": "Path 3465",
    d: "M14.913,36.309a15.709,15.709,0,0,1-5.762-1.082A15.429,15.429,0,0,1,.435,26.51a15.732,15.732,0,0,1-1.08-6.024A16.26,16.26,0,0,1,.623,14.439a16.729,16.729,0,0,1,12.071-9.9A1.1,1.1,0,0,1,13.126,6.7a14.33,14.33,0,0,0-7.345,3.95,14.23,14.23,0,0,0-4.22,9.87A13.275,13.275,0,0,0,15.139,34.1,14.478,14.478,0,0,0,27.9,25.76a14.816,14.816,0,0,0,1.057-3.226,1.1,1.1,0,1,1,2.163.432,16.951,16.951,0,0,1-1.206,3.694,16.436,16.436,0,0,1-3.348,4.781,16.6,16.6,0,0,1-5.347,3.6,16.258,16.258,0,0,1-6.047,1.269Z",
    transform: "translate(0.171 -1.195)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3466",
    "data-name": "Path 3466",
    d: "M33.414,22.434a1.1,1.1,0,0,1-.78-1.883,11.53,11.53,0,0,0,3.421-8A10.744,10.744,0,0,0,25.063,1.56a11.531,11.531,0,0,0-8,3.421,11.706,11.706,0,0,0-3,5.1,1.1,1.1,0,1,1-2.124-.6A14,14,0,0,1,19.973.415a13.59,13.59,0,0,1,5.054-1.06,13.156,13.156,0,0,1,5.038.9A12.908,12.908,0,0,1,37.358,7.55a13.156,13.156,0,0,1,.9,5.038A13.59,13.59,0,0,1,37.2,17.643a13.869,13.869,0,0,1-3.006,4.468A1.1,1.1,0,0,1,33.414,22.434Z",
    transform: "translate(-3.15 0.172)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3467",
    "data-name": "Path 3467",
    d: "M31.1,12.331a4.589,4.589,0,0,1-4.584-4.584,1.1,1.1,0,1,1,2.206,0A2.381,2.381,0,0,0,31.1,10.125a1.1,1.1,0,0,1,0,2.206Z",
    transform: "translate(-7.02 -1.758)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3468",
    "data-name": "Path 3468",
    d: "M32.233,26.74a4.589,4.589,0,0,1-4.584-4.584,1.1,1.1,0,1,1,2.206,0,2.381,2.381,0,0,0,2.378,2.378,1.1,1.1,0,0,1,0,2.206Z",
    transform: "translate(-7.319 -5.572)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3473",
    "data-name": "Path 3473",
    d: "M32.233,26.74a4.589,4.589,0,0,1-4.584-4.584,1.1,1.1,0,1,1,2.206,0,2.381,2.381,0,0,0,2.378,2.378,1.1,1.1,0,0,1,0,2.206Z",
    transform: "translate(-14.594 2.767)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3474",
    "data-name": "Path 3474",
    d: "M28.752,26.74a1.1,1.1,0,0,1,0-2.206,2.381,2.381,0,0,0,2.377-2.378,1.1,1.1,0,1,1,2.206,0A4.589,4.589,0,0,1,28.752,26.74Z",
    transform: "translate(12.009 8.374)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3475",
    "data-name": "Path 3475",
    d: "M28.752,26.74a1.1,1.1,0,0,1,0-2.206,2.381,2.381,0,0,0,2.377-2.378,1.1,1.1,0,1,1,2.206,0A4.589,4.589,0,0,1,28.752,26.74Z",
    transform: "translate(14.95 17.198)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3469",
    "data-name": "Path 3469",
    d: "M17.606,25.827a4.589,4.589,0,0,1-4.584-4.584,1.1,1.1,0,1,1,2.206,0,2.381,2.381,0,0,0,2.378,2.378,1.1,1.1,0,0,1,0,2.206Z",
    transform: "translate(-3.447 -5.331)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3470",
    "data-name": "Path 3470",
    d: "M43.881,48.9a1.1,1.1,0,0,1-1.031-.711,11.231,11.231,0,0,1-.717-4.61,1.1,1.1,0,1,1,2.2.115,9.039,9.039,0,0,0,.576,3.71,1.1,1.1,0,0,1-1.031,1.5Z",
    transform: "translate(-11.15 -11.259)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3471",
    "data-name": "Path 3471",
    d: "M48.98,69.467a1.1,1.1,0,0,1-.337-2.153,9.16,9.16,0,0,0,3.975-2.588,1.1,1.1,0,0,1,1.636,1.479,11.368,11.368,0,0,1-4.936,3.208A1.1,1.1,0,0,1,48.98,69.467Z",
    transform: "translate(-12.674 -17.036)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3472",
    "data-name": "Path 3472",
    d: "M49.085,61.68h0a8.783,8.783,0,0,1-4.565-1.273,10.538,10.538,0,0,1-2.72.36,9.971,9.971,0,0,1-5.028-1.355,9.858,9.858,0,0,1-3.092-2.834,10.421,10.421,0,0,1-1.66-3.754,11.45,11.45,0,0,1,1.337-8.311,11.664,11.664,0,0,1,2.987-3.4,11.183,11.183,0,0,1,3.11-1.687,11.161,11.161,0,0,1,6.9-8.935,10.05,10.05,0,0,1,3.74-.734,9.492,9.492,0,0,1,6.45,2.55,14.378,14.378,0,0,1,4.144,7.907,26.3,26.3,0,0,1,.446,7.068,20.125,20.125,0,0,1-2.4,8.288,12.094,12.094,0,0,1-4.851,4.833A10.132,10.132,0,0,1,49.085,61.68ZM45.4,58.344a6.412,6.412,0,0,0,3.683,1.13h0a7.956,7.956,0,0,0,3.757-1.012A9.894,9.894,0,0,0,56.8,54.5a17.937,17.937,0,0,0,2.134-7.387,24.1,24.1,0,0,0-.411-6.474,12.206,12.206,0,0,0-3.462-6.7A7.32,7.32,0,0,0,50.1,31.967,8.849,8.849,0,0,0,41.643,39.7c-.025.209-.042.417-.053.619a1.1,1.1,0,0,1-.811,1.008,9.442,9.442,0,0,0-6.608,11.013,7.9,7.9,0,0,0,3.712,5.169A7.764,7.764,0,0,0,41.8,58.561a8.4,8.4,0,0,0,2.572-.409A1.078,1.078,0,0,1,45.4,58.344Z",
    transform: "translate(-8.404 -7.877)",
    fill: "#22294b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotatoesBl);
export default __webpack_public_path__ + "static/media/Potatoes-bl.4965d54057a11d1e77ba9f087df01da0.svg";
export { ForwardRef as ReactComponent };